import { createContext } from "react";
import { RoleBasedAssessmentGoalFragmentFragment } from "types/graphql-schema";

export const RoleBasedAssessmentDevelopmentGoalsContext = createContext<{
  goals: RoleBasedAssessmentGoalFragmentFragment[];
  isOnDeliveryPage: boolean;
}>({
  goals: [],
  isOnDeliveryPage: false,
});
